import { Settings } from 'media/icons'
import OptionsHandler from './OptionsHandler'
import NavBarDropdown from './NavBarDropdown'
import { isRouteDisabled } from 'sections/utils'

export default (t, rights) => ({
	id: '1',
	label: t('options_section.caption'),
	link: isRouteDisabled(rights, '1') ? null : 'optionen',
	linkDisabled: isRouteDisabled(rights, '1'),
	withDropDown: true,
	icon: Settings,
	handler: OptionsHandler,
	NavAction: () => {},
	NavComponent: NavBarDropdown
})
